var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('adam',{attrs:{"company":_vm.company}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }